import React,{useState,useEffect} from 'react'
import TextField from '../../components/TextField'
import SubmitButton from '../../components/SubmitButton'
import {Error, Success} from '../../components/Status'
import {useUpdateFormCategory} from '../../hooks/formCategories/useUpdate'

const UpdateFormCategory = ({formCategory}) => {
    // STATES
    // PAYLOAD STATE
    const [state,setState]=useState({
        categoryId: formCategory.categoryId,
        categoryName:formCategory.categoryName,
        description:formCategory.description,
        activeStatus:formCategory.activeStatus
    })
    // MISC STATE
    const [error,setError]=useState("")
    const [success,setSuccess]=useState("")

    // MUTATION
    const {mutate:updateCategory,error:updateError,isLoading,isSuccess}=useUpdateFormCategory(formCategory.id,state)
    
    // HANDLERS
    // INPUT HANDLER
    const handleChange=({target:{name,value}})=>{
            setState({...state,[name]:value})
    }


    const handleCheck=()=>{
        setState({...state,activeStatus:!state.activeStatus})
    }


    // SUBMIT HANDLER
    const handleSubmit=(e)=>{
        e.preventDefault();
        // REFRESH ERROR
        setError('')
        updateCategory()
    }

    // EFFECTS
    useEffect(()=>{
        if(isSuccess){
            setSuccess("Form Category updated successfully")
            setTimeout(() => {
                window.location.reload()
            }, 2000);
        }
    },[isSuccess])

    useEffect(()=>{
        if(updateError){
            const message=updateError?.response?.data?.message
            setError(message)
        }
    },[updateError])

    return (
        <form className='w-full flex flex-col space-y-5' onSubmit={handleSubmit}>
            {success.length>0&&<Success>{success}</Success>}
            {error.length>0&&<Error>{error}</Error>}
            <TextField label='Name' required name='categoryName' value={state.categoryName} onChange={handleChange} />
            <TextField label='Description' name='description' type='textarea' value={state.description} onChange={handleChange} />
            {!formCategory.activeStatus&& <TextField type='checkbox' label='Activate' name='activeStatus' checked={state.activeStatus} onChange={handleCheck} />}
            <SubmitButton loading={isLoading}>Submit</SubmitButton>
        </form>
    )
}

export default UpdateFormCategory
